module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("19PSQ"))).then(() => parcelRequire('d0iPb'));